module.exports = __webpack_public_path__ + "static/media/smart_home_health.3854cb18.jpg";